import { Controller, useFormContext } from 'react-hook-form'

import { CheckBoxGroup, FF2 } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

import { suspiciousActivityInfoValidate, useSuspiciousActivityInfoValidate } from '../../../../../../hooks'

export const Structuring = () => {
  const { control } = useFormContext<SarEdit>()

  useSuspiciousActivityInfoValidate()

  return (
    <Controller
      name="suspiciousActivityInfo.structuring"
      control={control}
      rules={{
        validate: suspiciousActivityInfoValidate
      }}
      render={({ field }) => (
        <FF2
          field={field}
          label="32. Structuring"
          input={(props) => (
            <CheckBoxGroup
              {...props}
              data-qa={'32. Structuring'}
              direction={'vertical'}
              data={[
                { label: 'a. Alters or cancels transaction to avoid BSA record keeping requirement', value: 'a' },
                { label: 'b. Alters or cancels transaction to avoid CTR requirement', value: 'b' },
                { label: 'c. Suspicious inquiry by customer', value: 'c' },
                { label: 'd. Transaction(s) below BSA record keeping threshold', value: 'd' },
                { label: 'e. Transaction(s) below CTR threshold', value: 'e' },
                { label: 'z. Other', value: 'z' }
              ]}
            />
          )}
        />
      )}
    />
  )
}
